import type { Project } from '../types';

ObjectsNaviPanel.$inject = ['$resource'];

export interface ObjectsNaviPanel
  extends angular.resource.IResourceClass<angular.resource.IResource<any>> {
  getObjectNavi(
    params: {
      sectionId: string;
      public?: boolean;
      byHouse?: boolean;
    },
    success?: (resp: { data: Project[] }) => any,
    error?: (error: any) => any,
  ): angular.resource.IResource<Project[]>;
}

export function ObjectsNaviPanel($resource: angular.resource.IResourceService) {
  return $resource(
    '/api/',
    {},
    {
      getObjectNavi: {
        method: 'GET',
        url: '/api/object/navigation/section/:sectionId',
        isArray: false,
        interceptor: {
          response(response) {
            return response.data;
          },
        },
      },
    },
  ) as ObjectsNaviPanel;
}
